import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router'
import { getCatedata, getHomedata } from '../../api'
import Hearde from '../Hometwo/Hearde/Hearde'
import TopNav from '../Hometwo/Navlist/Navlist'
import './Category2.css'
import { insert_adv, remove_adv } from '../../method/addadv'
import Footer from '../Hometwo/Footer/Footer'
import { iframeLoad } from '../../method/analytics'

export default function Category() {
  const [data, setData] = useState([])
  const [cate, setCate] = useState([])
  /* 获取首页数据 */
  const getHome = () => {
    getHomedata().then(res => {
      setCate(res.data.category)
    })
  }
  const { search } = useLocation()

  let cataname = search.slice(6)

  /* 左上角导航控制 */
  const [flag, setFlag] = useState(false)
  const top_list = () => {
    setFlag(true)
  }
  // 判断view是否可以滚动
  flag ? (document.getElementsByTagName('body')[0].style.overflow = 'hidden') : (document.getElementsByTagName('body')[0].style.overflow = 'auto')

  const setflag = () => {
    setFlag(false)
  }
  /* 搜索栏 */
  const [searflag, setSearchflag] = useState(false)
  const setsear = () => {
    setSearchflag(true)
  }
  /* 关闭搜索栏 */
  const setSearch = () => {
    setSearchflag(false)
  }

  // 跳转详情
  // const goDetails = (para) => {
  //   window.location = "/page/details?gid=" + para;
  // };

  useEffect(() => {
    document.getElementsByTagName('body')[0].style.overflow = 'auto'
    //获取分类列表数据
    const getdata = () => {
      getCatedata(search).then(res => {
        // console.log("list");
        setData(res.data.list)
      })
    }

    getdata()
    getHome()

    if ((window.law_ntv_ad1, window.law_ntv_ad2)) {
      insert_adv('adv_1')
      insert_adv('adv_2')
      var pageLoadSecond = new Date().getTime()
      iframeLoad(pageLoadSecond)

      return () => {
        remove_adv('adv_1')
        remove_adv('adv_2')
      }
    }
  }, [search])

  return (
    <div className="category2">
      <Hearde cataname={cataname} top_list={top_list} setsear={setsear} searflag={searflag} setSearch={setSearch}></Hearde>
      <TopNav flag={flag} setflag={setflag} gamecata={cate}></TopNav>

      <div className="cate_con">
        {/* 广告一 */}
        <div className="adv_box">
          <p>advertisement</p>
          <div id="adv_1" dangerouslySetInnerHTML={{ __html: window.law_ntv_ad1 }}></div>
        </div>

        {/* <h2>{cataname}</h2> */}

        <ul>
          {data?.map(item => (
            <li key={item.gid}>
              <a href={'/page/details?gid=' + item.gid} className="dis_a">
                <img src={process.env.REACT_APP_BASEURL + item.icon} alt="" />
                <p>{item.name}</p>
              </a>
            </li>
          ))}
        </ul>
      </div>

      {/* 广告二 */}
      <div className="adv_box">
        <p>advertisement</p>
        <div id="adv_2" dangerouslySetInnerHTML={{ __html: window.law_ntv_ad2 }}></div>
      </div>

      {/* foot */}
      <Footer></Footer>
    </div>
  )
}
